const GroupPostComment = {
  text: "",
  share: { id: 0 },
  group: { id: 0 },
};

export default GroupPostComment;
